import React, { FC, Fragment } from 'react';
import { TableCell, TableRow, Chip } from '@mui/material';
import ActiveIndicator from 'components/users/shared/active-indicator/active-indicator.component';
import { useTranslation } from 'react-i18next';
import { User } from 'models/user';
import { Organization } from 'models/organization';
import { currentOrgVar } from 'apollo/reactive-variables/organization';
import { resolveUserOrganization } from 'utils/user-organization';

type TechniciansItemProps = {
    technician: User;
    onEditTechnicianClick: (technician: User) => void;
};

const TechniciansItem: FC<TechniciansItemProps> = ({ technician, onEditTechnicianClick }: TechniciansItemProps) => {
    const currentOrg = currentOrgVar();
    const { t: translate } = useTranslation();
    // Derived, not state: the list is keyed by index, so a cached value outlived its
    // row and showed the previous user's role and lab on a filter change.
    const userOrganization = resolveUserOrganization(technician, currentOrg._id);

    return (
        <TableRow
            hover
            sx={{ cursor: 'pointer' }}
            onClick={() => onEditTechnicianClick(Object.assign({}, technician, userOrganization))}
        >
            <Fragment>
                <TableCell sx={{ width: 10 }} align="center">
                    <ActiveIndicator isActive={!!userOrganization?.active} />
                </TableCell>
                <TableCell sx={{ width: 300 }}>
                    {technician.fullName}
                    {technician.isShared && (
                        <Chip
                            label={translate('common:SHARED_USER')}
                            size="small"
                            color="info"
                            variant="outlined"
                            sx={{ ml: 1 }}
                        />
                    )}
                </TableCell>
                <TableCell>{technician.email}</TableCell>
                <TableCell>{translate(userOrganization.role)}</TableCell>
                <TableCell>{(userOrganization.organization as Organization)?.name}</TableCell>
            </Fragment>
        </TableRow>
    );
};

export default TechniciansItem;
